<template>
  <!-- 單元細節 popover：點擊格子後貼齊格子彈出（設計稿 UnitPopover），點外部關閉、無遮罩 -->
  <div class="ur-sel-unit-popover-wrap" :style="wrapStyle" @click.stop>
    <div class="ur-sel-unit-popover">
      <div class="ur-sel-unit-pop-head">
        <span class="ur-sel-unit-pop-code">{{ unit.unit_code }}</span>
        <button
          class="ur-sel-unit-pop-close"
          type="button"
          :title="$t('URBANRENEWAL_SELECT.UNIT.CLOSE')"
          @click="$emit('close')"
        >&times;</button>
      </div>

      <div class="ur-sel-unit-pop-body">
        <template v-if="type === 'housing'">
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_AREA', { v: fmtArea(unit.area_ping) }) }}</div>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_UNIT_PRICE', { v: fmtNum(unit.unit_price) }) }}</div>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_TOTAL_PRICE', { v: fmtNum(unit.total_price) }) }}</div>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_GROUPS', { v: count }) }}</div>
        </template>

        <template v-else>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_TOTAL_PRICE', { v: fmtNum(unit.value) }) }}</div>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_SPEC', { v: unit.spec }) }}</div>
          <div class="ur-sel-unit-line">{{ $t('URBANRENEWAL_SELECT.UNIT.LINE_GROUPS', { v: count }) }}</div>
        </template>
      </div>

      <div v-if="type === 'housing' && unit.is_priority === false" class="ur-sel-unit-warn">
        <span class="ur-sel-unit-warn-icon">&#9888;</span>
        <span class="ur-sel-unit-warn-text">{{ $t('URBANRENEWAL_SELECT.UNIT.NONPRIORITY_HINT') }}</span>
      </div>

      <template v-if="alreadyAdded">
        <div class="ur-sel-unit-added">
          &#10003; {{ $t('URBANRENEWAL_SELECT.UNIT.ALREADY_ADDED') }}
        </div>
        <button
          class="ur-sel-unit-pop-remove"
          type="button"
          @click="$emit('remove', unit)"
        >
          {{ $t('URBANRENEWAL_SELECT.UNIT.CANCEL_SELECTION') }}
        </button>
      </template>
      <button
        v-else
        class="ur-sel-unit-pop-add"
        type="button"
        @click="$emit('add', unit)"
      >
        {{ $t('URBANRENEWAL_SELECT.UNIT.ADD_SELECTION') }}
      </button>
    </div>
  </div>
</template>

<script>
import moneyFormat from '../moneyFormat';

export default {
  name: 'UrbanRenewalSelectUnitDialog',

  mixins: [moneyFormat],

  props: {
    unit: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    alreadyAdded: {
      type: Boolean,
      default: false,
    },
    // 被點擊格子的 getBoundingClientRect()，用來把 popover 貼齊格子旁
    anchorRect: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      // 先移出畫面 + 隱藏，等量到自身尺寸再定位，避免定位前閃現
      wrapStyle: { top: '-9999px', left: '-9999px', visibility: 'hidden' },
    };
  },

  mounted() {
    this.$nextTick(this.reposition);
    document.addEventListener('click', this.onDocClick);
    // 捲動/縮放時 popover 會與格子錯位，直接關閉最單純
    window.addEventListener('resize', this.close);
    window.addEventListener('scroll', this.close, true);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
    window.removeEventListener('resize', this.close);
    window.removeEventListener('scroll', this.close, true);
  },

  methods: {
    // 坪數四捨五入到小數第一位（去除多餘的 .0）
    fmtArea(v) {
      if (v == null || v === '') return v;
      return Math.round(Number(v) * 10) / 10;
    },

    reposition() {
      const r = this.anchorRect;
      if (!r || !this.$el) return;
      const w = this.$el.offsetWidth || 232;
      const h = this.$el.offsetHeight || 0;
      // 預設放格子右側；右側空間不足則翻到左側
      let left = r.right + 6;
      if (left + w > window.innerWidth - 4) left = r.left - w - 6;
      if (left < 4) left = 4;
      // 對齊格子上緣；超出視窗下緣則上推
      let top = r.top;
      if (top + h > window.innerHeight - 4) top = window.innerHeight - h - 4;
      if (top < 4) top = 4;
      this.wrapStyle = { top: top + 'px', left: left + 'px' };
    },

    onDocClick(e) {
      if (!e.target.closest('.ur-sel-unit-popover-wrap')) this.close();
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
